import { isEqual } from 'lodash'

export const getFormChanges = (
  initialValues: any,
  targetValues: any,
  labelMapping: any = {},
  ignoreKeys = [],
) => {
  const values: string[] = []

  try {
    for (const targetValueKey in targetValues) {
      if (
        !isEqual(targetValues[targetValueKey], initialValues[targetValueKey]) &&
        !ignoreKeys.includes(targetValueKey)
      ) {
        values.push(labelMapping[targetValueKey] || targetValueKey)
      }
    }
  } catch {
    //
  }

  return values
}
